import { envConfig } from '../envConfig'

export const tablesOrdersCollection = envConfig.tablesCollection
export const usersOrdersCollection = envConfig.userOrdersCollection
export const deliveriesCollection = envConfig.deliveriesCollection
export const keywordsCollection = envConfig.keywordsCollection
export const restaurantsCollection = envConfig.restaurantsCollection